import _formatDate from 'date-fns/format';
import _isValid from 'date-fns/isValid';

export default function formatDate(
  date: Date | number,
  format: string = 'dd/MM/yyyy',
  defaultValue = new Date()
) {
  try {
    return _formatDate(date, format);
  } catch (ex) {
    console.log(ex);

    if (_isValid(Date)) {
      return _formatDate(new Date(), format);
    }

    return defaultValue;
  }
}
